import * as t from 'io-ts';

import {makeApiType, makeDefaultValueType, makeEnumRuntimeType} from './apiTypes';

export enum CustomFieldResourceTypesEnum {
  ACCOUNT = 'account',
  CARD = 'card',
  INBOX = 'inbox',
  TEAMMATE = 'teammate',
}

export enum CustomFieldsEnum {
  STRING = 'string',
  DATETIME = 'datetime',
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  TEAMMATE = 'teammate',
  INBOX = 'inbox',
  UNKNOWN = 'unknown',

  // Not used custom fields, required for display purposes in settings custom fields.
  EMAIL_DOMAIN = 'email_domains',
}

export const RCustomFieldResourceType = makeEnumRuntimeType(CustomFieldResourceTypesEnum);
const RCustomFieldType = makeEnumRuntimeType(CustomFieldsEnum);
const RSafeCustomFieldType = makeDefaultValueType(RCustomFieldType, CustomFieldsEnum.UNKNOWN);

/*
 * Runtime type.
 */

const RCustomFieldBaseDirty = t.readonly(
  t.type({
    type: RSafeCustomFieldType,
    name: t.string,
    description: t.string,
  }),
  'customBaseField',
);

const RCustomFieldDirty = t.intersection([
  RCustomFieldBaseDirty,
  t.readonly(
    t.type({
      id: t.Integer,
      url: t.string,
      nameSlug: t.string,
      origin: t.string,
      resourceType: RCustomFieldResourceType,
      updatedAt: t.Integer,
      createdAt: t.Integer,
    }),
    'customField',
  ),
]);

const RCustomFieldImpactedRule = t.readonly(
  t.type({
    id: t.number,
  }),
  'customFieldImpactedRule',
);

/*
 * Type.
 */

export interface CustomFieldBaseModel extends t.TypeOf<typeof RCustomFieldBaseDirty> {}
export interface CustomFieldModel extends t.TypeOf<typeof RCustomFieldDirty> {}
export interface CustomFieldImpactedRule extends t.TypeOf<typeof RCustomFieldImpactedRule> {}
export const RCustomField = t.clean<CustomFieldModel>(RCustomFieldDirty as any);
export const RCustomFields = t.readonlyArray(RCustomField);
export const RCustomFieldImpactedRules = t.readonlyArray(RCustomFieldImpactedRule);

/*
 * IO methods.
 */

export function parseCustomField(src: any): CustomFieldModel {
  return {
    id: src.id,
    url: src.url,
    type: src.type,
    name: src.name,
    nameSlug: src.name_slug,
    origin: src.origin,
    description: src.description,
    resourceType: src.resource_type,
    updatedAt: src.updated_at || Date.now(), // TODO: Return UpdatedAt from server.
    createdAt: src.created_at || Date.now(),
  };
}

export function parseCustomFields(src: any): ReadonlyArray<CustomFieldModel> {
  return src.map(parseCustomField);
}

export function parseCustomFieldImpactedRules(src: any): ReadonlyArray<CustomFieldImpactedRule> {
  return src.map((r: any) => ({id: r.id}));
}

/*
 * API type.
 */

export const ApiCustomField = makeApiType('customField', RCustomField, parseCustomField);
export const ApiCustomFields = makeApiType('customFields', RCustomFields, parseCustomFields);
export const ApiCustomFieldImpactedRules = makeApiType(
  'customFields',
  RCustomFieldImpactedRules,
  parseCustomFieldImpactedRules,
);

/*
 * Api Helpers.
 */

export enum CustomFieldErrorCodesEnum {
  CUSTOM_FIELD_ALREADY_EXIST = 'custom_field_already_exist',
}
